import { render, staticRenderFns } from "./SubApplicationTitle.vue?vue&type=template&id=f86fc3ec&scoped=true&"
import script from "./SubApplicationTitle.vue?vue&type=script&lang=js&"
export * from "./SubApplicationTitle.vue?vue&type=script&lang=js&"
import style0 from "./SubApplicationTitle.vue?vue&type=style&index=0&id=f86fc3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86fc3ec",
  null
  
)

export default component.exports